import { useEffect, useState } from "react";
import Spreadsheet from "react-spreadsheet";

export const EconomicsPricesSpreadsheet = ({ priceData, setPriceData }) => {
  
  const [data, setData] = useState(priceData?.map((p,i) => {
    return [{value: new Date(p.date)?.toISOString()?.split('T')?.[0]}, {value: Number(p.price)}];
  }));

  useEffect(() => {
    setPriceData(data?.map((d,i) => {
      return {date: (d?.[0]?.value), price: Number(d?.[1]?.value)};
    }));
  }, [data, setPriceData]);

  return (
    <Spreadsheet data={data} onChange={setData} />
  );
};